import { Checkbox } from 'antd'
import { FC } from 'react'
import { FCC } from 'types'

const CheckBoxCustom: FCC<{
 disabled?: boolean
 value?: boolean
 onChange?: (v?: boolean) => void
}> = ({ onChange, value, children, disabled }) => {
 return (
  <Checkbox
   disabled={disabled}
   onChange={({ target }) => {
    onChange?.(target.checked)
   }}
   checked={value}
   value={value}
  >
   {children}
  </Checkbox>
 )
}
export default CheckBoxCustom
